<template>
    <div class="reset-container">
      <div class="reset-box">
        <h2>Reset Password</h2>
        <form @submit.prevent="resetPassword">
          <div class="form-group">
            <label for="password">New Password</label>
            <input
              v-model="password"
              type="password"
              id="password"
              required
              minlength="6"
            />
          </div>
  
          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <input
              v-model="confirmPassword"
              type="password"
              id="confirmPassword"
              required
            />
          </div>
  
          <button :disabled="loading" type="submit">
            {{ loading ? "Resetting..." : "Reset Password" }}
          </button>
        </form>
  
        <p v-if="successMessage" class="success">{{ successMessage }}</p>
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
  
        <div class="mt-4 text-center text-sm">
          <router-link to="/login" class="text-blue-600 hover:underline"
            >Back to Login</router-link
          >
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    name: "ResetPassword",
    data() {
      return {
        password: "",
        confirmPassword: "",
        successMessage: "",
        errorMessage: "",
        loading: false,
      };
    },
    computed: {
      token() {
        return this.$route.params.token; // e.g., ?token=abc123
      },
    },
    methods: {
      async resetPassword() {
        this.successMessage = "";
        this.errorMessage = "";
  
        if (!this.token) {
          this.errorMessage = "Missing or invalid reset token.";
          return;
        }
  
        if (this.password !== this.confirmPassword) {
          this.errorMessage = "Passwords do not match.";
          return;
        }
  
        this.loading = true;
  
        try {
          const response = await axios.post(
            "https://api.roberms.com/fundraise/reset/password/:token",
            {
              token: this.token,
              password: this.password,
            }
          );
  
          this.successMessage =
            response.data.message || "Password reset successfully!";
        } catch (error) {
          this.errorMessage =
            error.response.data.message || "Something went wrong.";
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .reset-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: #f5f5f5;
  }
  .reset-box {
    background: white;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    width: 350px;
  }
  h2 {
    text-align: center;
    margin-bottom: 1.5rem;
  }
  .form-group {
    margin-bottom: 1rem;
  }
  label {
    display: block;
    margin-bottom: 0.3rem;
  }
  input {
    width: 100%;
    padding: 0.6rem;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  button {
    width: 100%;
    padding: 0.7rem;
    background: #007bff;
    border: none;
    color: white;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
  }
  button:disabled {
    background: #999;
    cursor: not-allowed;
  }
  .success {
    color: green;
    text-align: center;
    margin-top: 1rem;
  }
  .error {
    color: red;
    text-align: center;
    margin-top: 1rem;
  }
  </style>
  